// extracted by mini-css-extract-plugin
var _1 = "LayoutScrollBorders_border_horizontal__be66a";
var _2 = "LayoutScrollBorders_borders_vertical__152f2";
var _3 = "LayoutScrollBorders_shadow_horizontal__1c7ca";
var _4 = "LayoutScrollBorders_shadow_vertical__e8728";
export { _1 as "border_horizontal", _2 as "borders_vertical", _3 as "shadow_horizontal", _4 as "shadow_vertical" }
